export default __webpack_public_path__ + "static/media/paso10-icon.ca3a835e.svg";